import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursorList: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCursorList"><Path d="M10 3H21V5H10V3Z" fill="currentColor"/><Path d="M15 7H21V9H15V7Z" fill="currentColor"/><Path d="M7.17962 21.8599L1.85547 6.85547L16.8599 12.1796L12.7269 16.3127L17.4144 21.0002L16.0002 22.4144L11.3127 17.7269L7.17962 21.8599Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCursorList;
